
import { useEffect, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import ScanImage from './ScanImage';
import "./carousel.css";
import { ArrowLeft } from '@mui/icons-material';
import { ArrowRight } from '@mui/icons-material';
import LogoMark from '../../../../../Assets/Logo_Mark_Shadow.svg';
import { Box, useTheme } from '@mui/material';

// Shared sx object for carousel nav buttons
const navButtonSx = {
    display: {
        xs: 'none',
        md: 'flex'
    },
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 38,
    height: 62,
    borderRadius: 3,
    border: '1px solid rgba(255, 255, 255, 0.45)',
    backgroundColor: 'rgba(223, 228, 241, 0.70)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 10px 22px rgba(20, 30, 55, 0.16)',
    transition: 'all 180ms ease',
    '&:hover': {
        backgroundColor: 'rgba(223, 228, 241, 0.52)',
        borderColor: 'rgba(255, 255, 255, 0.7)',
        transform: 'translateY(-50%) scale(1.03)'
    }
};

// Shared nav button component
function CarouselNavButton({ side, icon }: { side: 'left' | 'right', icon: React.ReactNode }) {
    return (
        <Box
            sx={{
                ...navButtonSx,
                [side]: 16
            }}
        >
            {icon}
        </Box>
    );
}

export default function ScanImageCarousel(props: any) {
    const { imagePaths } = props;
    const theme = useTheme();
    const [items, setItems] = useState<any>([
        LogoMark
    ]);

    useEffect(() => {
        if (imagePaths.length) {
            let images = imagePaths.map((snap: any) => snap);
            setItems(images);
        } else {
            setItems([LogoMark])
        }

    }, [imagePaths]);

    const renderNextButton = () => (
        <CarouselNavButton side="right" icon={<ArrowRight sx={{ fontSize: 45, color: theme.palette.secondary.dark }} />} />
    );

    const renderPrevButton = () => (
        <CarouselNavButton side="left" icon={<ArrowLeft sx={{ fontSize: 45, color: theme.palette.secondary.dark }} />} />
    );

    const isPlaceholder = items.length === 1 && items[0] === LogoMark;

    if (items.length === 1) {
        return (
            // the padding bottom is to give some spacing when there is only a single image - if no padding - the image touches the dimension fields texts. 
            // When there are multiple images - this is not an issue because the navigation dots provide natural spacing from the dimension fields
            <Box sx={{ pb: 1.5 }}>
                <ScanImage
                    key={0}
                    item={items[0]}
                    isPlaceholder={isPlaceholder}
                />
            </Box>
        );
    } else {
        // This is multiple scan images
        return (
            <AliceCarousel
                mouseTracking
                infinite={true}
                renderPrevButton={renderPrevButton}
                renderNextButton={renderNextButton}
            >
                {items.map((item: any, i: any) => {
                    return <ScanImage key={i} item={item} isPlaceholder={false}></ScanImage>
                })}
            </AliceCarousel>
        )
    }
}